import axios from '../utils/axios';

export default function addRecruiterCompany(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/recruiter-company-list',  data )

    )
}
